import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ClientProviderService {
  private customerIdSubject = new BehaviorSubject<string | null>(null);
  private documentSubject = new BehaviorSubject<string | null>(null);

  customerId$ = this.customerIdSubject.asObservable();
  document$ = this.documentSubject.asObservable();

  updateCustomerId(token: string | null): void {
    this.customerIdSubject.next(token);
  }

  updateDocument(document: string | null): void {
    this.documentSubject.next(document);
  }

  get customerId(): string | null {
    return this.customerIdSubject.value;
  }

  get document(): string | null {
    return this.documentSubject.value;
  }
}
